import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";

import { CellComponentProps } from "../types";

type UserIntegrationsListItemIdCellProps = CellComponentProps;

const UserIntegrationsListItemIdCell = ({ integration }: UserIntegrationsListItemIdCellProps) => {
  return (
    <TextEllipsis tooltip={integration.id} tooltipWidthMode="maxWidthSm">
      {(props) => (
        <Typography {...props} tag="p" variant="p-body3">
          {integration.id}
        </Typography>
      )}
    </TextEllipsis>
  );
};

export default UserIntegrationsListItemIdCell;
